import { JsonApiProperty } from './index';

export class BaseEntity {
  id?: string;

  @JsonApiProperty({ resolver: (_value, _attrs, data) => data.meta, readOnly: true })
  meta?: Record<string, any>;
}
